"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends")),
    _react = _interopRequireDefault(require("react")),
    _SrtCaptions = _interopRequireDefault(require("../components/SrtCaptions")),
    _AddonsContext = require("../../../../context/AddonsContext");

function SrtCaptions(a) {
  return _react["default"].createElement(_AddonsContext.AddonsContextConsumer, null, function (b) {
    var c = b.constants.CAPTIONS;
    return _react["default"].createElement(_SrtCaptions["default"], (0, _extends2["default"])({}, a, {
      SRT_CAPTIONS: c("SRT_CAPTIONS")
    }));
  });
}

var _default = SrtCaptions;
exports["default"] = _default;